module.exports = __webpack_public_path__ + "scaglie-su-nastro-nw2.jpg?8ae6c5ee9188a49b50e56f40a532e50a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scaglie-su-nastro-nw2.jpg
// module id = 251
// module chunks = 0